import React from 'react'
import PropTypes from 'prop-types'
import { Link, generatePath } from 'react-router-dom'
import { List, ListItem, ListItemText } from '@material-ui/core'
import routesThermometer from '../../thermometer/routesThermometer'

export default class ViewerRole extends React.Component {
  render(){
    let routeThermometerList = generatePath(routesThermometer.list, {
      company: this.props.nameCompanySlug,
    })
    return (
      <React.Fragment>
        <List>
          <ListItem>
            <ListItemText primary={this.props.nameCompany} className="sidebar-title" />
          </ListItem>
          <ListItem
            button
            component={Link}
            to={routeThermometerList}
            selected={
              this.props.history.location.pathname ===
              routeThermometerList
            }
          >
            <ListItemText primary="Ver termómetros" className="sidebar-item"/>
          </ListItem>
        </List>
        <List>
          <ListItem>
            <ListItemText primary="Termómetro" className="sidebar-title" />
          </ListItem>
          <ListItem
            button
            component={Link}
            to={routesThermometer.what}
            selected={
              this.props.history.location.pathname ===
              routesThermometer.what
            }
          >
            <ListItemText primary="¿Qué es?" className="sidebar-item" />
          </ListItem>
          <ListItem>
            <ListItemText primary="Usuario" className="sidebar-title" />
          </ListItem>
          <ListItem onClick={this.props.logout} button>
            <ListItemText
              primary="Cerrar Sesión"
              className="sidebar-item"
            />
          </ListItem>
        </List>
      </React.Fragment>
    )
  }
}

ViewerRole.propTypes = {
  history: PropTypes.object,
  logout: PropTypes.func.isRequired,
  nameCompanySlug: PropTypes.string.isRequired,
  nameCompany: PropTypes.string.isRequired,
}
